// being used
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { GRAPH_COLORS } from "../../../types/micellinous-constants";

const renderCustomBarLabel = ({ x, y, width, height, value, category }) => {
  const xPosValue = x + width / 2;
  const yPosValue = "90%";
  const xPosCategory = x + 5;
  const yPosCategory = 275;
  const fontSize = "0.5em";

  return (
    <>
      <text
        x={xPosValue}
        y={yPosValue}
        fill="#fff"
        fontSize={fontSize}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {`${value}%`}
      </text>
      <text
        x={xPosCategory}
        y={yPosCategory}
        fill="#fff"
        fontSize={fontSize}
        textAnchor="middle"
        dominantBaseline="central"
        transform={`rotate(-90, ${xPosCategory}, ${yPosCategory})`}
      >
        {category}
      </text>
    </>
  );
};

const PPEChart = ({ aggregatedData, timeUnits }) => {
  const formatChartData = () => {
    const chartData = timeUnits.map((unit) => ({ name: unit }));

    Object.entries(aggregatedData).forEach(([key, dataByTimeUnit], index) => {
      chartData.forEach((dataPoint) => {
        const data = dataByTimeUnit[dataPoint.name] || {
          compliantAnswers: 0,
          nonCompliant: 0,
          totalQuestions: 0,
        };
        const total = data.totalQuestions;
        const compliant = data.compliantAnswers;
        const nonCompliant = data.nonCompliant;

        const totalPercentage =
          total > 0
            ? (((compliant + nonCompliant) / total) * 100).toFixed(2)
            : 0;
        const compliantPercentage =
          total > 0 ? ((compliant / total) * 100).toFixed(2) : 0;
        const nonCompliantPercentage =
          total > 0 ? ((nonCompliant / total) * 100).toFixed(2) : 0;

        dataPoint[key] = parseFloat(totalPercentage);
        dataPoint[`${key} Compliant`] = parseFloat(compliantPercentage);
        dataPoint[`${key} Non-Compliant`] = parseFloat(nonCompliantPercentage);
      });
    });

    return chartData;
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <span
          style={{
            color: "#4B5320",
            marginRight: "5px",
            marginLeft: "10px",
            display: "inline-block",
            width: "10px",
            height: "10px",
            backgroundColor: GRAPH_COLORS[0],
            borderRadius: "50%",
          }}
        ></span>
        <span>Compliant</span>
        <span
          style={{
            color: "orange",
            marginRight: "5px",
            marginLeft: "10px",
            display: "inline-block",
            width: "10px",
            height: "10px",
            backgroundColor: GRAPH_COLORS[1],
            borderRadius: "50%",
          }}
        ></span>
        <span>Non-Compliant</span>
      </div>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={formatChartData()}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barCategoryGap={20}
          barSize={30}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis
            label={{ value: "Compliance", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />
          {Object.keys(aggregatedData).map((key, index) => (
            <React.Fragment key={key}>
              <Bar
                key={key}
                dataKey={key}
                fill={GRAPH_COLORS[index % GRAPH_COLORS.length]}
                stackId={key}
              >
                <LabelList
                  dataKey={key}
                  content={(props) =>
                    renderCustomBarLabel({ ...props, category: key })
                  }
                />
              </Bar>
              <Bar
                key={`${key} Compliant`}
                dataKey={`${key} Compliant`}
                stackId={key}
                fill={GRAPH_COLORS[0]}
              >
                <LabelList
                  dataKey={`${key} Compliant`}
                  content={(props) =>
                    renderCustomBarLabel({ ...props, category: `${key}` })
                  }
                />
              </Bar>
              <Bar
                key={`${key} Non-Compliant`}
                dataKey={`${key} Non-Compliant`}
                stackId={key}
                fill={GRAPH_COLORS[1]}
              ></Bar>
            </React.Fragment>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PPEChart;
